import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `delayMs`. For a value that feeds
 * a request: `useDeferredValue` only defers the render, so a query keyed on it
 * still sends one request per keystroke.
 */
const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
